module.exports = __webpack_public_path__ + "img/media_14.6e5f1a45.jpg";